<template>
  <nav :class="{ scrolled: isScrolled }" id="navbar">
    <div class="nav-container">
      <router-link :to="{ name: 'HomePage' }" class="logo">Digital Twin Hub</router-link>
      <ul class="nav-links">
        <li>
          <router-link :to="{ name: 'HomePage' }" :class="{ active: activeNav==='HomePage' }">首页</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'TutorialsPage' }" :class="{ active: activeNav==='TutorialsPage' }">教程</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ResourcesPage' }" :class="{ active: activeNav==='ResourcesPage' }">资源</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ArticlesPage' }" :class="{ active: activeNav==='ArticlesPage' }">资讯</router-link>
        </li>
        <li><a href="#about">关于</a></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBarComponent',
  data() {
    return {
      isScrolled: false
    };
  },
  computed: {
    activeNav() {
      // 从当前路由获取激活的导航项
      const routeName = this.$route.name || 'HomePage';
      
      // 详情页映射到对应的列表页
      if (routeName === 'ArticleDetailPage') {
        return 'ArticlesPage';
      }
      if (routeName === 'TutorialDetailPage') {
        return 'TutorialsPage';
      }
      
      return routeName;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    }
  }
};
</script>

<style scoped>
.nav-links a.active {
  color: #00d4ff; /* 当前模块高亮 */
}

/* 导航栏样式（组件局部样式） */
nav {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 20px 50px;
  background: rgba(16, 22, 58, 0.3);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
}

nav.scrolled {
  padding: 15px 50px;
  background: rgba(16, 22, 58, 0.5);
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  background: linear-gradient(45deg, #00d4ff, #0066ff);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: none;
}

.nav-links {
  display: flex;
  gap: 30px;
  list-style: none;
}

.nav-links a {
  color: #ffffff;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  padding: 5px 0;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #00d4ff, #0066ff);
  transition: width 0.3s ease;
}

.nav-links a:hover::after {
  width: 100%;
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }
  nav {
    padding: 15px 20px;
  }
}
</style>
